import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import Button from '../../Button';

import {
  CloseRed as CloseRedIcon,
  Copilot as CopilotIcon,
  ArrowRightBold as ArrowRightIcon,
} from '@icons/common';

const SuggestionsToolbar = React.memo(({ suggestions, onApply, onChange }) => {
  const [index, setIndex] = useState(0);

  const handleNext = useCallback(() => {
    const nextIndex = (index + 1) % suggestions.length;
    setIndex(nextIndex);
    onChange(suggestions[nextIndex]);
  }, [index, suggestions, onChange]);

  const handleApply = useCallback(() => {
    onApply(suggestions[index]);
  }, [index, onApply]);

  const handleCancel = useCallback(() => {
    onApply({ id: suggestions[index]?.id, text: '' });
  }, [onApply]);

  return (
    <>
      <StyledSuggestionArrow functional onClick={handleNext}>
        <ArrowRightIcon width={5} height={10} />
      </StyledSuggestionArrow>
      <StyledSuggestionToolbar>
        <CopilotIcon width={15} height={15} />
        <StyledLabel>
          {index + 1} из {suggestions.length}
        </StyledLabel>
        <StyledAcceptButton functional onClick={handleApply}>
          Применить
        </StyledAcceptButton>
        <StyledCloseButton functional onClick={handleCancel}>
          <CloseRedIcon width={17} height={17} />
        </StyledCloseButton>
      </StyledSuggestionToolbar>
    </>
  );
});

SuggestionsToolbar.propTypes = {
  onApply: PropTypes.func,
  onChange: PropTypes.func,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

SuggestionsToolbar.defaultProps = {
  onChange: Function.prototype,
  suggestions: [],
};

const StyledSuggestionArrow = styled(Button)`
  background: #f3f9ff;
  width: 20px;
  height: 26px;
  position: absolute;
  right: 0px;
  bottom: 60px;
  border-radius: 20px 0px 0px 20px;
  text-align: center;
  line-height: 26px;
`;

const StyledSuggestionToolbar = styled.div`
  background: #d9ebff;
  height: 32px;
  bottom: -32px;
  position: absolute;
  display: flex;
  right: 0px;
  border-radius: 0px 0px 10px 10px;
  padding: 0 7px;
  align-items: center;

  :before {
    content: '';
    position: absolute;
    top: 0;
    width: calc(100% - 20px);
    left: 10px;
    background: white;
    height: 1px;
  }
`;

const StyledAcceptButton = styled(Button)`
  border: 1px solid #5bba01;
  color: #5bba01;
  background: #fff;
  font-size: 12px;
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 4px;
`;

const StyledCloseButton = styled(Button)`
  display: flex;
`;

const StyledLabel = styled.div`
  color: #007aff;
  width: 60px;
  margin: 0 40px 0 4px;
`;

export default SuggestionsToolbar;
